const $ = require('jquery');
import _ from 'underscore';
import QuickWizard from '../../components/QuickWizard/QuickWizard';
import EditChecker from '../../components/EditChecker/EditChecker';
import run from '../../utilities/run';
import { validateOnAllSelectChanges } from "../../utilities/select2able";
import { isPresent } from "../../utilities/general";
import SubmitModalFlow from "../../components/SubmitModalFlow/SubmitModalFlow";
import { SUCCESS_MODAL_TIMEOUT_WITH_REDIRECT } from "../../constants";
import DetailsTab from './detailsTab.js';
import PackagingTab from './packagingTab.js';
import ReviewTab from './reviewTab.js';
import {loadEditValues} from "./editOrderTypeWizard.js";
import {handleQueryParamTraversalToWizardTab} from '../../utilities/jumpToWizardLogic';

const targetSelector = "#create-order-type-form";

run(targetSelector, (mainEl) => {
  
  const editFlag = mainEl.data("edit-flag");
  if(editFlag){
    loadEditValues(mainEl);
  }
  attachWizard(mainEl);
  setupEditChecker();
});

function setupEditChecker() {
  EditChecker.bindNavigation();
  EditChecker.bindChangeListener(targetSelector);
  EditChecker.bindChangeListener("span.select2");
  EditChecker.bindCancelButton("#create-order-type-cancel-btn");
}

function attachWizard(el) { 
  const hiddenAddressInput = $(".ot-details-tab");
  const validator = el.validate({
    errorPlacement: function (error, element) {
      let appendClosest = $(element).data('error-placement-append-closest');
      if (appendClosest) {
        $(element).closest(appendClosest).append(error);
      } else {
        error.insertAfter(element);
      }
    }
  })

  validator.settings.ignore = ":disabled,:hidden";
  const quickWizard = new QuickWizard(el, {
    tabletWidthNavStep: 844,
    mobileWidthNavStep: 502,
    customRules: {
      ".orderTypeCodeInput":{
        errorMessageSelector: "#create-order-type-duplicate",
        isValid: ({ input, done }) => {
          return orderTypeDuplicateCheck(input, done);
        }
      },
    },
    shouldNavigateToForm: ({ targetForm, direction, currentForm, done }) => {
      // Any time we go traverse backwards, just let us
      if (direction === "BACKWARDS") {
        return true;
      }

      if(currentForm.filter('.ot-review-tab').length){
        reviewTab.didNavigateToForm();
      }
      
      //Handle general validations on forward traversal
      let allPrevInputs = quickWizard.allPreviousFieldsUpToTargetForm(targetForm);
      if (!quickWizard.areInputsValid(allPrevInputs, { displayErrors: true })) {
        quickWizard.goToFirstIncompleteForm();
        return false;
      }
    },
    didNavigateToForm: function ({ currentForm }) {
      if(currentForm.filter('.ot-review-tab').length){
        reviewTab.didNavigateToForm();
      }
    }
  })
  
  quickWizard.init();

  const detailsTab = new DetailsTab(quickWizard);
  const packagingTab = new PackagingTab(quickWizard);
  const reviewTab = new ReviewTab(quickWizard);

  function orderTypeDuplicateCheck(input, done) {
    let orderTypeCodeValue = input.val();
    const orderTypeList = el.data("dup-chck-list");
    const editFlag = el.data("edit-flag");
    const isDup = el.data("dup-flag");
    const orderTypeObj = el.data("edit-order-type-data");
    const dupCheck = _.find(orderTypeList, function (obj) {
      return (obj.ortTypeCode == orderTypeCodeValue.toUpperCase() && obj.ortRtlId != 0);
    });
    const requiredErrorMsg = el.find("#create-order-type-required");
    let notEmptyChck;
    if(!input.attr('disabled')){
      if(orderTypeCodeValue != ""){
        notEmptyChck = true;
        requiredErrorMsg.hide();
      }else{
        requiredErrorMsg.show();
        notEmptyChck = false;
      }
      const isValid = orderTypeCodeValidation(orderTypeCodeValue);
      if(!notEmptyChck){
        el.find("#create-order-type-duplicate").hide();
        done(false,{displayErrors:false});
      }else if(!isValid){
        el.find("#create-order-type-duplicate").hide();
        done(false,{displayErrors:false});
      }else if (dupCheck) {
        if (editFlag && orderTypeObj.code.toUpperCase() === orderTypeCodeValue.toUpperCase() && !isDup) {
          done(true,{displayErrors:false});
        } else {
          done(false,{displayErrors:true});
        }
      }else if(orderTypeCodeValue.toUpperCase() =="B2B" || orderTypeCodeValue.toUpperCase() == "B2C"){
        done(false,{displayErrors:true});
      }else {
        done(true,{displayErrors:true});
      }
    }else{
      let qSimErrorEle = el.find("#create-order-type-duplicate");
      if(qSimErrorEle.find('label').is(':visible')) {
        done(false,{displayErrors:true});
      } else {
        done(true,{displayErrors:false});
        requiredErrorMsg.hide();
      }
      
    }
    return done;
  }

  function orderTypeCodeValidation(orderTypeCodeValue) {
    const errorMsgEl = el.find("#create-order-type-invalid");
    if(orderTypeCodeValue == ""){
      errorMsgEl.hide()
      return true;
    }else if ((!(/[a-zA-Z]/).test(orderTypeCodeValue) || orderTypeCodeValue.length < 3)) {
      errorMsgEl.show();
      return false;
    } else {
      errorMsgEl.hide()
      return true;
    }
  }
  function orderTypeValidation(input, currentDropShip) {
    let orderTypeCodeValue = input.val();
    const orderTypeList = el.data("dup-chck-list");
    const orderTypeObj = el.data("edit-order-type-data");
    const dupCheck = _.find(orderTypeList, function (obj) {
      return (obj.ortTypeCode == orderTypeCodeValue.toUpperCase() && obj.ortDropShip == currentDropShip && obj.ortRtlId != 0);
    });
    if (dupCheck) {
      el.find("#create-order-type-duplicate").show();
    } else {
      el.find("#create-order-type-duplicate").hide();
    }
    
  }
  el.find('.order-type-retailer-list').on("change", function(){
    orderTypeValidation(el.find('.orderTypeCodeInput'), el.find('.order-type-dropShip-switch').is(":checked"));
  });
  el.find('.order-type-dropShip-switch').on("change", function(){
    orderTypeValidation(el.find('.orderTypeCodeInput'), el.find('.order-type-dropShip-switch').is(":checked"));
  });
  validateOnAllSelectChanges();
  handleQueryParamTraversalToWizardTab(quickWizard);
}



// WEBPACK FOOTER //
// ./src/pages/orderType/orderTypeWizard.js